/**
 * downloadFile.js defines request methods for the Download page
 */

 import Axios from 'axios';
 import React from 'react';
 import { getMarkitDigitalApiToken } from '../api/apiToken/markitDigitalApiToken';
 
 async function getAccessToken() {
	return '';//await getMarkitDigitalApiToken(false);
 }
 /**
  * Method used to execute a data request
  * @param {String} url [Fully qualified URL for a data request]
  * @param {String} method [Request method, defaults to 'GET']
  * @param {Function} callback [Callback to which a response will be passed]
  * @param {Object} params [URL parameters as key value pairs]
  * @param {Object} postData [Data to be included in body of POST request]
  */
 export const executeDataRequest = async (url, method, params, postData, responseType) => {
     const config = {
         data: null,
         method: method || 'GET',
         url: url,
         responseType
     }
 
     const accessToken = await getAccessToken();
     if (accessToken) {
         config.headers = {
             Authorization: accessToken.token_type + ' ' + accessToken.access_token
         }
     }
 
     const result = await Axios
         .request(config)
         .then(response => {
			return [true, response];
         }, reject => {
			if (reject.response.data && reject.response.data.type === 'application/json'){
				return [false, reject.response.data.text()];
			}
			throw new Error(reject.message)
		})
         .catch(error => {
             console.error('ERROR: ', error);
			 throw new Error(`Axios call error, error: ${error.message} `);
         });
	if (result[0]) {
		return result[1];
	}
	// get rejected message.
	const result1 = await result[1];
	const reject1 = JSON.parse(result1);
	throw new Error(`Error: ${reject1.error.code} , ${reject1.error.message} `);
 }
 
 /**
  * Executes download request either by opening file in a new tab or downloads it in current tab
  *
  * @public
  * @method executeDownloadRequest
  * @param {*} url - the url to open
  * @param {*} mimeType - type of content the url points to.
  * @param {string} downloadName - name to download file with
  * @param {boolean} [shouldDownload = false] - if true request is downloaded else opened in new tab(always downloaded for IE)
  */
 export const executeDownloadRequest = async (url, mimeType, downloadName, shouldDownload = false) => {
	const response = await  executeDataRequest(url,'GET',null,null,'blob');
	const downloadData = new Blob([response.data], { type: mimeType })
	if (window.navigator && window.navigator.msSaveBlob) {
		// Internet Explorer workaround
		window.navigator.msSaveBlob(downloadData, downloadName)
	} else {
		// other browsers
		const downloadUrl = (window.URL || window.webkitURL).createObjectURL(downloadData)
		window.open(downloadUrl)
	}
 }
 
 /**
  * Executes download request either by opening file in a new tab or downloads it in current tab
  *
  * @public
  * @method executeDownloadRequestViaAnchor
  * @param {string} downloadName - name to download file with
  * @param {*} mimeType - type of content the url points to
  * @param {*} url - the url to open
  */
 export const executeDownloadRequestViaAnchor = async (downloadName, mimeType, url) => {
     const response = await executeDataRequest(url, 'GET', null, null, 'blob');
	 const contentType = mimeType ? mimeType : response.headers['content-type'].split(';')[0];
	 const downloadData = new Blob([response.data], { type: contentType })
	 if (window.navigator && window.navigator.msSaveBlob) {
		 // Internet Explorer workaround
		 window.navigator.msSaveBlob(downloadData, downloadName);
	 } else {
		 // other browsers
		 const a = document.createElement('a');
		 const downloadUrl = (window.URL || window.webkitURL).createObjectURL(downloadData);

		 if (contentType === 'application/pdf' || contentType === 'application/xml') {
			window.location = downloadUrl;
		 } else {
			 a.href = downloadUrl
			 if (downloadName) a.download = downloadName;
			 // make link invisible and add to the DOM (Firefox)
			 document.getElementsByTagName('body')[0].appendChild(a);
			 a.click();
			 document.getElementsByTagName('body')[0].removeChild(a);
			 window.close();
		 }          
	 }
 }